import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-left bg-blue-100 px-2 rounded-lg"
}
const _hoisted_2 = { class: "flex pt-1" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons align-middle text-slate-500" }, "undo", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons align-middle text-slate-500" }, "redo", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "flex pt-1" }
const _hoisted_10 = { class: "basis-20" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "flex py-1" }
const _hoisted_14 = { class: "basis-20" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "flex pt-1" }
const _hoisted_18 = { class: "basis-20" }
const _hoisted_19 = { class: "" }
const _hoisted_20 = { class: "hidden lg:inline-block" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "flex-none material-icons align-middle text-slate-500 w-6" }, "sort", -1)
const _hoisted_22 = ["data-index"]
const _hoisted_23 = { class: "flex" }
const _hoisted_24 = { class: "grow flex pl-2" }
const _hoisted_25 = ["value", "onInput"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 0,
  class: ""
}
const _hoisted_28 = { class: "px-2 bg-blue-50 py-1 my-1 rounded-lg" }
const _hoisted_29 = { class: "flex" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons align-middle text-slate-500" }, "help", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons align-middle text-slate-500" }, "delete", -1)
const _hoisted_33 = { class: "flex my-1" }
const _hoisted_34 = { class: "basis-20" }
const _hoisted_35 = { class: "" }
const _hoisted_36 = ["value", "onInput"]
const _hoisted_37 = { class: "flex my-1" }
const _hoisted_38 = { class: "flex" }
const _hoisted_39 = { class: "w-full" }
const _hoisted_40 = ["value", "onInput"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "flex" }, null, -1)
const _hoisted_42 = { class: "py-1" }
const _hoisted_43 = { class: "" }
const _hoisted_44 = { class: "flex" }
const _hoisted_45 = { class: "flex-none" }
const _hoisted_46 = { class: "flex-1 mx-1" }
const _hoisted_47 = ["value", "onInput"]
const _hoisted_48 = { class: "flex-1 truncate ml-2" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons align-middle text-slate-500" }, "delete", -1)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = { class: "flex my-1" }
const _hoisted_53 = { class: "pl-6" }
const _hoisted_54 = { class: "flex" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = ["value", "onInput"]
const _hoisted_57 = { class: "basis-20 ml-auto whitespace-nowrap" }
const _hoisted_58 = ["checked", "onChange", "id"]
const _hoisted_59 = ["for"]
const _hoisted_60 = /*#__PURE__*/_createElementVNode("i", { class: "flex-none material-icons align-middle text-slate-500 w-6 mr-1" }, "east", -1)
const _hoisted_61 = { key: 1 }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = /*#__PURE__*/_createElementVNode("i", { class: "flex-none material-icons align-middle text-slate-500 w-6 ml-6" }, "add_box", -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("i", {
  class: "material-icons align-middle text-slate-500 w-6 mr-1",
  style: {"color":"#aaaaaa"}
}, "add_box", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmPanel = _resolveComponent("ConfirmPanel")!
  const _component_ColorPalette = _resolveComponent("ColorPalette")!

  return (_ctx.graph_data && _ctx.is_edit_mode)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "pr-2 cursor-pointer disabled:opacity-30",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.undo && _ctx.undo(...args))),
            disabled: !_ctx.isUndoable
          }, _hoisted_5, 8, _hoisted_3),
          _createElementVNode("button", {
            class: "cursor-pointer disabled:opacity-30",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redo && _ctx.redo(...args))),
            disabled: !_ctx.isRedoable
          }, _hoisted_8, 8, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("editor.title")), 1)
          ]),
          _createElementVNode("input", {
            type: "text",
            value: _ctx.graph_data.title,
            onInput: _cache[2] || (_cache[2] = (event) => _ctx.onTextInputOnGraph(event, 'title')),
            onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.emitGraphUpdated && _ctx.emitGraphUpdated(...args)), ["enter"])),
            onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.emitGraphUpdated && _ctx.emitGraphUpdated(...args))),
            class: "ml-2 bg-gray-50 border border-gray-300 text-gray-900 rounded-lg block w-full px-2",
            required: ""
          }, null, 40, _hoisted_12)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("editor.url")), 1)
          ]),
          _createElementVNode("input", {
            type: "text",
            value: _ctx.graph_data.related_url,
            onInput: _cache[5] || (_cache[5] = (event) => _ctx.onTextInputOnGraph(event, 'related_url')),
            onKeyup: _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.emitGraphUpdated && _ctx.emitGraphUpdated(...args)), ["enter"])),
            onBlur: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.emitGraphUpdated && _ctx.emitGraphUpdated(...args))),
            class: "ml-2 bg-gray-50 border border-gray-300 text-gray-900 rounded-lg block w-full px-2",
            required: ""
          }, null, 40, _hoisted_16)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("editor.nodes")), 1)
          ]),
          _createElementVNode("div", {
            class: "cursor-pointer",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.sortNodes && _ctx.sortNodes(...args)))
          }, [
            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("editor.sort")), 1),
            _hoisted_21
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.graph_data.graph_data.elements.nodes, (node) => {
          return (_openBlock(), _createElementBlock("div", {
            key: node.data.id,
            ref_for: true,
            ref: "node_panel",
            "data-index": node.data.id
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("i", {
                    class: "material-icons align-middle text-slate-500 w-6",
                    style: _normalizeStyle(`color:${node.data.color}`)
                  }, "square", 4),
                  _createElementVNode("input", {
                    type: "text",
                    value: node.data.label,
                    onInput: (event) => _ctx.onTextInputOnNode(event, node),
                    onKeyup: _cache[9] || (_cache[9] = _withKeys(
//@ts-ignore
(...args) => (_ctx.emitGraphUpdated && _ctx.emitGraphUpdated(...args)), ["enter"])),
                    onBlur: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.emitGraphUpdated && _ctx.emitGraphUpdated(...args))),
                    class: "bg-gray-50 border border-gray-300 text-gray-900 rounded-lg block w-full px-2",
                    required: ""
                  }, null, 40, _hoisted_25)
                ]),
                _createElementVNode("div", {
                  class: "flex-none w-6 cursor-pointer",
                  onClick: ($event: any) => (_ctx.toggleNodePanel(node.data.id!))
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["material-icons align-middle text-slate-500 transform transition-transform", node.data.id === _ctx.nodeWithPanel ? 'rotate-180' : ''])
                  }, "expand_more", 2)
                ], 8, _hoisted_26)
              ])
            ]),
            (node.data.id === _ctx.nodeWithPanel)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", {
                        class: "flex cursor-pointer select-none",
                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.details && _ctx.details(...args)))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("editor.details")), 1),
                        _hoisted_30
                      ]),
                      _hoisted_31,
                      _createElementVNode("div", {
                        class: "flex cursor-pointer select-none",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setAttempt('delete_node')))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("history.delete_node")), 1),
                        _hoisted_32
                      ])
                    ]),
                    (_ctx.attempt === 'delete_node')
                      ? (_openBlock(), _createBlock(_component_ConfirmPanel, {
                          key: 0,
                          message_id: "history.may_delete_node",
                          yes_id: "history.yes_delete",
                          no_id: "history.cancel",
                          onYes: _cache[13] || (_cache[13] = ($event: any) => (_ctx.confirm())),
                          onNo: _cache[14] || (_cache[14] = ($event: any) => (_ctx.cancel()))
                        }))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t("history.type")), 1)
                      ]),
                      _createElementVNode("input", {
                        type: "text",
                        value: node.data.type,
                        onInput: (event) => _ctx.onTextInputOnNode(event, node, 'type'),
                        onKeyup: _cache[15] || (_cache[15] = _withKeys(
//@ts-ignore
(...args) => (_ctx.emitGraphUpdated && _ctx.emitGraphUpdated(...args)), ["enter"])),
                        onBlur: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.emitGraphUpdated && _ctx.emitGraphUpdated(...args))),
                        class: "ml-2 bg-gray-50 border border-gray-300 text-gray-900 rounded-lg block w-full px-2",
                        required: ""
                      }, null, 40, _hoisted_36)
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", {
                        class: "pr-6 cursor-pointer",
                        onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.colorPaletteToggle && _ctx.colorPaletteToggle(...args)))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("history.color")), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", null, [
                            _createElementVNode("i", {
                              class: _normalizeClass(["material-icons align-middle text-slate-500 cursor-pointer transform transition-transform", _ctx.isPaletteOpen ? 'rotate-180' : '']),
                              onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.colorPaletteToggle && _ctx.colorPaletteToggle(...args)))
                            }, "expand_less", 2)
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            _createVNode(_component_ColorPalette, {
                              onSetColor: (e) => _ctx.onTextInputOnNode({ target: { value: e } }, node, 'color', true),
                              colors: _ctx.colors,
                              isSimple: !_ctx.isPaletteOpen,
                              selected_color: node.data.color
                            }, null, 8, ["onSetColor", "colors", "isSimple", "selected_color"])
                          ])
                        ]),
                        (_ctx.isPaletteOpen)
                          ? (_openBlock(), _createElementBlock("input", {
                              key: 0,
                              type: "text",
                              value: node.data.color,
                              onInput: (event) => _ctx.onTextInputOnNode(event, node, 'color'),
                              onKeyup: _cache[19] || (_cache[19] = _withKeys(
//@ts-ignore
(...args) => (_ctx.emitGraphUpdated && _ctx.emitGraphUpdated(...args)), ["enter"])),
                              onBlur: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.emitGraphUpdated && _ctx.emitGraphUpdated(...args))),
                              class: "mt-2 bg-gray-50 border border-gray-300 text-gray-900 rounded-lg block w-full px-2",
                              required: ""
                            }, null, 40, _hoisted_40))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _hoisted_41,
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t("editor.edges")), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredEdges, (edge) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: edge.data.id,
                        class: "mb-4"
                      }, [
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("i", {
                              class: "flex-none material-icons align-middle text-slate-500 w-6",
                              style: _normalizeStyle(`color:${edge.data.color}`)
                            }, "east", 4)
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("input", {
                              type: "text",
                              value: edge.data.label,
                              onInput: (event) => _ctx.onTextInputOnEdge(event, edge),
                              onKeyup: _cache[21] || (_cache[21] = _withKeys(
//@ts-ignore
(...args) => (_ctx.emitGraphUpdated && _ctx.emitGraphUpdated(...args)), ["enter"])),
                              onBlur: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.emitGraphUpdated && _ctx.emitGraphUpdated(...args))),
                              class: "bg-gray-50 border border-gray-300 text-gray-900 rounded-lg block w-full px-2",
                              required: ""
                            }, null, 40, _hoisted_47)
                          ]),
                          _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.nodeLabel(edge.data.target)), 1),
                          _createElementVNode("div", {
                            class: "flex-none cursor-pointer",
                            onClick: ($event: any) => (_ctx.setAttempt('delete_edge', edge.data.id))
                          }, _hoisted_51, 8, _hoisted_49)
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("div", null, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["material-icons align-middle text-slate-500 cursor-pointer transform transition-transform", _ctx.selected_edge_palette === edge.data.id ? 'rotate-180' : '']),
                                  onClick: ($event: any) => (_ctx.update_selected_edge_palette(edge.data.id))
                                }, "expand_less", 10, _hoisted_55)
                              ]),
                              _createElementVNode("div", null, [
                                _createVNode(_component_ColorPalette, {
                                  onSetColor: (e) => _ctx.onTextInputOnEdge({ target: { value: e } }, edge, 'color', true),
                                  colors: _ctx.edgeColors,
                                  isSimple: _ctx.selected_edge_palette !== edge.data.id,
                                  selected_color: edge.data.color
                                }, null, 8, ["onSetColor", "colors", "isSimple", "selected_color"])
                              ])
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              value: edge.data.color,
                              onInput: (event) => _ctx.onTextInputOnEdge(event, edge, 'color'),
                              onKeyup: _cache[23] || (_cache[23] = _withKeys(
//@ts-ignore
(...args) => (_ctx.emitGraphUpdated && _ctx.emitGraphUpdated(...args)), ["enter"])),
                              onBlur: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.emitGraphUpdated && _ctx.emitGraphUpdated(...args))),
                              class: "ml-2 bg-gray-50 border border-gray-300 text-gray-900 rounded-lg block w-full px-2",
                              required: ""
                            }, null, 40, _hoisted_56), [
                              [_vShow, _ctx.selected_edge_palette === edge.data.id]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              value: "foo",
                              checked: edge.data.directed,
                              onChange: (event) => _ctx.onCheckboxOnEdge(event, edge, 'directed'),
                              class: "bg-gray-50 mr-1",
                              required: "",
                              id: 'directed_' + edge.data.id
                            }, null, 40, _hoisted_58),
                            _createElementVNode("label", {
                              for: 'directed_' + edge.data.id
                            }, _toDisplayString(_ctx.$t("history.direction")), 9, _hoisted_59)
                          ])
                        ]),
                        (_ctx.attempt === 'delete_edge' && edge.data.id === _ctx.edgeToDelete)
                          ? (_openBlock(), _createBlock(_component_ConfirmPanel, {
                              key: 0,
                              message_id: `history.may_delete_edge`,
                              yes_id: `history.yes_delete`,
                              no_id: "history.cancel",
                              onYes: _cache[25] || (_cache[25] = ($event: any) => (_ctx.confirm())),
                              onNo: _cache[26] || (_cache[26] = ($event: any) => (_ctx.cancel()))
                            }, null, 8, ["message_id", "yes_id"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _createElementVNode("div", {
                      onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.showNodesForNewEdge && _ctx.showNodesForNewEdge(...args))),
                      class: "cursor-pointer select-none"
                    }, [
                      _hoisted_60,
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("history.add_edge")), 1)
                    ]),
                    (_ctx.isNodesVisibleForNewEdge)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nodesForNewEdge, (node2) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: node2.data.id
                            }, [
                              _createElementVNode("div", {
                                onClick: ($event: any) => (_ctx.addNewEdge(node2.data.id!)),
                                class: "cursor-pointer truncate"
                              }, [
                                _hoisted_63,
                                _createTextVNode(" " + _toDisplayString(node2.data.label), 1)
                              ], 8, _hoisted_62)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_22))
        }), 128)),
        _createElementVNode("div", {
          onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.addNewNode && _ctx.addNewNode(...args))),
          class: "cursor-pointer select-none pl-2"
        }, [
          _hoisted_64,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("history.add_node")), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}